import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import { searchTestsThunk, setIsLoading, initTestsThunk, getTestsActions } from '../../store/tests';

import CategoriesSuper from './CategoriesSuper';
import { getLabConfig, getCategories } from '../../utils/api';

import MenuContext from '../../store/MenuContext';
import LabIDContext from '../../store/LabIDContext';
import CTS_CustomHome from '../Home/CTS_Home.js';
import XYZLABS_CustomHome from '../Home/XYZLABS_Home.js';
import CategoryMenuClasses from './CategoryMenu.module.css';


function FileDisplay({ filePath, fallbackComponent, labid }) {
  const [fileExists, setFileExists] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkFile = async () => {
      try {
        const response = await fetch(filePath, { method: 'HEAD' });
        setFileExists(response.ok);
      } catch (error) {
        setFileExists(false);
      } finally {
        setLoading(false);
      }
    };

    checkFile();
  }, [filePath]);

  if (loading) {
    return <p>Loading...</p>;
  }
		 const components = {
		  CTS: () => <div><CTS_CustomHome/></div>,
		  XYZLABS: () => <div><XYZLABS_CustomHome/></div>,
		};

	const DynamicComponent = components[labid];
  return fileExists ? (
    <div style={{textAlign: 'center'}}>
      {/* Display content if the file exists */}
	  <DynamicComponent/>
      {/* You can add more content here, like displaying the file itself */}
    </div>
  ) : (
    fallbackComponent || <p>File not found.</p>
  );
}
const CategorySuperMenu = () => {
	const navigate = useNavigate();
	const labid = useContext(LabIDContext);
	const menuTheme = useContext(MenuContext);
		
	const [categories, setCategories] = useState([]);
	const [topCat, setTopCat] = useState([]);
	let topCatN='';
	let topCatD='';

	const shopAllHandler = async (event) => {
		sessionStorage.setItem("searchTerm", '');
		dispatch(getTestsActions().setSearch(''));
		dispatch(getTestsActions().clearCategories());
		dispatch(initTestsThunk(sessionStorage.getItem("topcatn"),sessionStorage.getItem("topcatn"),''));
		navigate(`availableTests`);	
				
			};

    useEffect(() => {
        async function fetchCategories() {
            const fetchedCategories = await getCategories('1');
            setCategories(fetchedCategories);
			//const fetchedCategories2 = await getCategories('2');
            //setTopCat(fetchedCategories2);
        }
        fetchCategories();
    }, []);
	useEffect(() => {
        async function fetchCategories2() {
			const fetchedCategories2 = await getCategories('2');
            setTopCat(fetchedCategories2);
        }
        fetchCategories2();
    }, []);
	if(topCat.length !==0) {
		topCatN=topCat[0].Name;
		topCatD=topCat[0].Description;
		sessionStorage.setItem("topcatn",topCatN)
		sessionStorage.setItem("topcatd",topCatD)
	};
	// Split categories
	const discoverCategory = categories.find((cat) => cat.Name === "Discover Employer Services");
	const otherCategories = categories.filter((cat) => cat.Name !== "Discover Employer Services");

	// Render all categories
	const categoriesList = (
	  <>
	    <div className={CategoryMenuClasses.dtctests}>
	      {otherCategories.map((category) => {
	        const mysubCat = category.SubCategories;
	        return (
	          <div key={category.ID} className={CategoryMenuClasses.categoryItem}>
	            <span className={CategoryMenuClasses.categoryItemHeader}>{category.Name}</span>
	             <CategoriesSuper
	              SuperCat={category.Name}
	              SubCat={mysubCat}
	              Supermenu="1"
	            />
	          </div>
	        );
	      })}
	    </div>

	  </>
	);
	const [searchTerm, setSearchTerm] = useState('');
    const isInitial = useRef(true);
    const dispatch = useDispatch();
    const testsState = useSelector(state => state.tests);
    
	useEffect(() => {
        if(!isInitial.current && searchTerm !== ''){
			console.log('start search');
			const searchTimeout =  setTimeout(() => {
				dispatch(setIsLoading());
				dispatch(searchTestsThunk(searchTerm,sessionStorage.getItem("topcatn"),sessionStorage.getItem("topcatn")));
				sessionStorage.setItem("searchTerm", searchTerm);
				navigate(`/availableTests`);
			}, 750);
            return () => {
                clearTimeout(searchTimeout);
            };
        }

        isInitial.current = false;

        
    }, [searchTerm, dispatch, isInitial]);
    return (
        <div className={CategoryMenuClasses.categoriesmenusuper}>
			{menuTheme === "HAMBURGER" &&
				<div className={CategoryMenuClasses.pageimage}>
				  <div className={CategoryMenuClasses.categoriesupertext}>
					<div className={CategoryMenuClasses.h1cat}>{topCatN}</div>
					<div className={CategoryMenuClasses.h2cat}>{topCatD}</div>
					<label htmlFor='testSearch' className={CategoryMenuClasses.searchLabel}>
						<span className="sr-only">Search tests by name</span>
						<i className={CategoryMenuClasses.searchIcon}><FontAwesomeIcon icon={faMagnifyingGlass}/></i>
						<input type='search' id='testSearch' name='testSearch' className={CategoryMenuClasses.headerSearch}  placeholder='Search Test Name'  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)} />
					</label>

					<button onClick={shopAllHandler} className={CategoryMenuClasses.buttonShopAll} >ALL TESTS</button>
				  </div>
				</div>
			}
			<FileDisplay filePath={`./${labid}_Home.js`} labid={labid} />
			
            {categoriesList}
        </div>
    );
};

export default CategorySuperMenu;